import { parsePhoneNumber } from 'awesome-phonenumber';
import auth from 'services/auth';
import NavLink from 'components/navLink';

export function parseNumber(number, countryCode) {
  if (!number) { return null; }
  return parsePhoneNumber(number, { regionCode: countryCode || auth.user.country });
}

export function getInternational(number, countryCode) {
  if (!number) { return ''; }
  // Always fallback to the original number if we can't parse it
  const parsed = parseNumber(number, countryCode);
  return parsed.valid ? parsed.number.e164 : number;
}

export function getNational(number, countryCode) {
  if (!number) { return ''; }
  // Always fallback to the original number if we can't parse it
  const parsed = parseNumber(number, countryCode);
  return parsed.valid ? parsed.number.national : number;
}

const handleTelephoneLink = e => { e.stopPropagation(); };
export function getTelephoneLink(number, countryCode) {
  if (!number) { return null; }
  const parsed = parseNumber(number, countryCode);
  const nat = parsed.valid ? parsed.number.national : number;
  const inter = parsed.valid ? parsed.number.e164 : number;
  return <NavLink href={'tel:' + inter} onClick={handleTelephoneLink}>{nat}</NavLink>;
}

export function getBestHomeNumber(numbers, countryCode) {
  if (!numbers) { return null; }
  numbers = numbers.filter(n => n.number);

  const t = auth.enumValues.phoneNumberType;
  const number = numbers.find(n => n.type === t.mobile)
    || numbers.find(n => n.type === t.home)
    || numbers.find(n => n.type === t.work)
    || numbers.find(n => n.type === t.afterhours)
    || numbers.find(n => n.type === t.other);

  return getNational(number?.number, countryCode);
}

export function getBestWorkNumber(numbers, countryCode) {
  if (!numbers) { return null; }
  numbers = numbers.filter(n => n.number);

  const t = auth.enumValues.phoneNumberType;
  const number = numbers.find(n => n.type === t.work)
    || numbers.find(n => n.type === t.mobile)
    || numbers.find(n => n.type === t.afterhours)
    || numbers.find(n => n.type === t.home)
    || numbers.find(n => n.type === t.other);

  return getNational(number?.number, countryCode);
}

export function getBestFaxNumber(numbers, countryCode) {
  if (!numbers) { return null; }

  const t = auth.enumValues.phoneNumberType;
  const number = numbers.find(n => n.number && n.type === t.fax);

  return getNational(number?.number, countryCode);
}